import { createTheme } from "@mui/material";

export const DEFAULT_THEME = {
  color: "#00897b",
  mode: "light",
};

export const LIGHT_THEME_COLORS = [
  { name: "Teal", color: "#00897b" },
  { name: "Blue", color: "#1976d2" },
  { name: "Indigo", color: "#3949ab" },
  { name: "Deep purple", color: "#5e35b1" },
  { name: "Green", color: "#2e7d32" },
  { name: "Cyan", color: "#00838f" },
  { name: "Deep orange", color: "#e64a19" },
  { name: "Blue grey", color: "#455a64" },
];

export const DARK_THEME_COLORS = [
  { name: "Teal", color: "#4db6ac" },
  { name: "Light blue", color: "#4fc3f7" },
  { name: "Cyan", color: "#4dd0e1" },
  { name: "Green", color: "#66bb6a" },
  { name: "Amber", color: "#ffca28" },
  { name: "Orange", color: "#ffa726" },
  { name: "Purple", color: "#ba68c8" },
  { name: "Pink", color: "#f06292" },
];

export const resolveUserTheme = (theme) => {
  if (!theme || typeof theme !== "object") {
    return DEFAULT_THEME;
  }

  return {
    color:
      typeof theme.color === "string" && theme.color
        ? theme.color
        : DEFAULT_THEME.color,
    mode: theme.mode === "dark" ? "dark" : "light",
  };
};

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: DEFAULT_THEME.color,
    },
    secondary: {
      main: "#f50057",
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: DEFAULT_THEME.color,
      light: "#4db6ac",
      dark: "#00695c",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#f50057",
    },
  },
});

export const getRootModalStyle = (width) => {
  return {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width,
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow: 24,
    //padding: "16px",
  };
};

export const defaultBodyTableCell = {
  fontSize: 18,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

export const getDefaultHeadTableCell = (width) => {
  return {
    minWidth: width,
    fontSize: 18,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    backgroundColor: "primary.light",
    color: "primary.contrastText",
  };
};

export const redBodyTableCell = {
  fontSize: 18,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  color: "orange",
};

export const greenBodyTableCell = {
  fontSize: 18,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  color: "green",
};

export const defaultTableButton = {
  marginTop: "16px",
  marginLeft: "8px",
  backgroundColor: "background.paper",
  color: "text.primary",
};

export const defaultRedButton = {
  marginTop: "16px",
  marginLeft: "8px",
  backgroundColor: "background.paper",
  color: "error.main",
};
